import { createSlice } from "@reduxjs/toolkit"
import actions from "../../../actions";

export const rePtmReducer = createSlice({
    name: 'rePtmReducer',
    initialState: {
        isLoading: false,
        error: null,
        changed: null,
        paged: null,
        list: null,
        tree: null,
		ptms: [],
    },
    reducers: {
        setLoading: (state) => {
            state.isLoading = true
            state.changed = null
        },
        setError: (state, action) => {
            state.isLoading = false
            state.error = action.payload
        },
        getPagedSuccess: (state, action) => {
            state.isLoading = false
            state.paged = action.payload
        },
        getListSuccess: (state, action) => {
            state.isLoading = false
            state.list = action.payload
        },
        getTreeSuccess: (state, action) => {
            state.isLoading = false
            state.tree = action.payload.sort((a, b) => 
                a.code.localeCompare(b.code, undefined, { numeric: true, sensitivity: 'base' }
            ))
        },
        getPtmByIdsSuccess: (state, action) => {
            state.isLoading = false
			// state.ptms = [...state.ptms, 
			// 	...action.payload.result.filter(p => !state.ptms.map(n => n.id).includes(p.id))]
            state.list = action.payload
        },
        createSuccess: (state,action) => {
            state.isLoading = false
            state.changed = action.payload ? actions.create : null
        },
        saveSuccess: (state,action) => {
            state.isLoading = false
            state.changed = action.payload ? actions.update : null
        },
        clear: (state) => {
			state.ptms = []
            state.isLoading = false
            state.changed = null
            state.error = null
        },
    }
})

export default rePtmReducer.reducer